<script lang="ts">
const registeredRefs = new Set<Ref<boolean>>()

export function hideAll() {
  ;[...registeredRefs.values()].forEach((v) => {
    v.value = false
  })
}
</script>
<script setup lang="ts">
import { ref, type Ref, onBeforeUnmount } from 'vue'

const isOpen = ref(false)
registeredRefs.add(isOpen)

onBeforeUnmount(() => {
  registeredRefs.delete(isOpen)
})
</script>

<template>
  <div @click="isOpen = true">
    <slot />
    <Teleport v-if="isOpen" to="body">
      <div class="seat-modal__wrapper" @click.self.stop="isOpen = false">
        <slot name="popper" />
      </div>
    </Teleport>
  </div>
</template>

<style lang="scss">
.seat-modal {
  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
